// import PropTypes from "prop-types"
// import React from "react"
// import { useSelector } from "react-redux"
// import { createSelector } from "reselect"
// import { Routes, Route } from "react-router-dom"
// import { layoutTypes } from "./constants/layout"
// // Import Routes all
// import { authProtectedRoutes, publicRoutes } from "./routes"

// // Import all middleware
// import Authmiddleware from "./routes/route"

// // layouts Format
// import VerticalLayout from "./components/VerticalLayout/"

// import NonAuthLayout from "./components/NonAuthLayout"

// // Import scss
// import "./assets/scss/theme.scss"

// // Import Firebase Configuration file
// // import { initFirebaseBackend } from "./helpers/firebase_helper";

// // import fakeBackend from "./helpers/AuthType/fakeBackend"

// // Activating fake backend
// // fakeBackend()

// // const firebaseConfig = {
// //   apiKey: process.env.REACT_APP_APIKEY,
// //   authDomain: process.env.REACT_APP_AUTHDOMAIN,
// //   databaseURL: process.env.REACT_APP_DATABASEURL,
// //   projectId: process.env.REACT_APP_PROJECTID,
// //   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
// //   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
// //   appId: process.env.REACT_APP_APPID,
// //   measurementId: process.env.REACT_APP_MEASUREMENTID,
// // };

// // init firebase backend
// // initFirebaseBackend(firebaseConfig);

// const getLayout = layoutType => {
//   let Layout = VerticalLayout
//   switch (layoutType) {
//     case layoutTypes.VERTICAL:
//       Layout = VerticalLayout
//       break
//     case layoutTypes.HORIZONTAL:
//       Layout = HorizontalLayout
//       break
//     default:
//       break
//   }
//   return Layout
// }

// const App = () => {
//   const LayoutProperties = createSelector(
//     state => state.Layout,
//     layout => ({
//       layoutType: layout.layoutType,
//     })
//   )

//   const { layoutType } = useSelector(LayoutProperties)

//   const Layout = getLayout(layoutType)

//   return (
//     <React.Fragment>
//       <Routes>
//         {publicRoutes.map((route, idx) => (
//           <Route
//             path={route.path}
//             element={<NonAuthLayout>{route.component}</NonAuthLayout>}
//             key={idx}
//             exact={true}
//           />
//         ))}

//         {authProtectedRoutes.map((route, idx) => (
//           <Route
//             path={route.path}
//             element={
//               <Authmiddleware>
//                 <Layout>{route.component}</Layout>
//               </Authmiddleware>
//             }
//             key={idx}
//             exact={true}
//           />
//         ))}
//       </Routes>
//     </React.Fragment>
//   )
// }

// App.propTypes = {
//   layout: PropTypes.any,
// }

// export default App

// import PropTypes from "prop-types"
// import React from "react"
// import { Routes, Route } from "react-router-dom"

// // Import Routes
// import { authProtectedRoutes, publicRoutes } from "./routes"

// // Import Middleware
// import Authmiddleware from "./routes/route"

// // Layouts
// import VerticalLayout from "./components/VerticalLayout/"
// import NonAuthLayout from "./components/NonAuthLayout"

// // Theme SCSS
// import "./assets/scss/theme.scss"

// const App = () => {
//   // Ab koi layout selector nahi – direct VerticalLayout use kar rahe hain
//   // Agar future mein dark/light ya horizontal chahiye to alag se implement kar sakte ho

//   return (
//     <React.Fragment>
//       <Routes>
//         {/* Public Routes (Login, Register, Forgot Password etc.) */}
//         {publicRoutes.map((route, idx) => (
//           <Route
//             path={route.path}
//             element={<NonAuthLayout>{route.component}</NonAuthLayout>}
//             key={idx}
//             exact={true}
//           />
//         ))}

//         {/* Protected Routes (Dashboard, Profile, Reports etc.) */}
//         {authProtectedRoutes.map((route, idx) => (
//           <Route
//             path={route.path}
//             element={
//               <Authmiddleware>
//                 <VerticalLayout>{route.component}</VerticalLayout>
//               </Authmiddleware>
//             }
//             key={idx}
//             exact={true}
//           />
//         ))}
//       </Routes>
//     </React.Fragment>
//   )
// }

// App.propTypes = {
//   layout: PropTypes.any,
// }

// export default App

import React from "react"
import { Routes, Route } from "react-router-dom"

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import Middleware
import Authmiddleware from "./routes/route"

// Layouts
import VerticalLayout from "./components/VerticalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Theme SCSS
import "./assets/scss/theme.scss"

const App = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* Public Routes (Login, Register, Forgot Password etc.) */}
        {publicRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
          />
        ))}

        {/* Protected Routes (Dashboard, Profile, Reports etc.) */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware>
                <VerticalLayout>{route.component}</VerticalLayout>
              </Authmiddleware>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

export default App
